<template>
    <div class="loader" role="status" aria-live="polite">
        <span class="loader-spinner" aria-hidden="true"></span>
    </div>
</template>

<script>
export default {
    name: "loader",
};
</script>

<style lang="scss">
.loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.46);
}

.loader-spinner {
  display: block;
  width: 4rem;
  height: 4rem;
  border: 0.25rem solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: loader-spin 0.9s linear infinite;
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loader-spinner {
    animation-duration: 2.4s;
  }
}
</style>
